/**
 * Matches viewers who have asked their operating system to minimise motion.
 * Exported so tests can stub `window.matchMedia` against the exact string the
 * web player queries.
 */
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const isMp4 = (url: string): boolean => url.split('?')[0].toLowerCase().endsWith('.mp4');

export const resolveVideoSource = (sources: string[]): string | undefined =>
  sources.find(isMp4) ?? sources[0];

export type VideoTimeUpdate = {
  currentTime: number;
  duration: number;
};

export type Props = {
  sources: string[];
  description: string;
  /**
   * Web-only still image shown before playback begins. not supported on native.
   */
  posterUrl?: string;
  /**
   * Starts playback without user interaction. Off by default, and always forced
   * to muted when on, per WCAG 1.4.2. Suppressed entirely for viewers who
   * prefer reduced motion.
   */
  autoPlay?: boolean;
  /**
   * suppressed for viewers who prefer reduced motion.
   */
  loop?: boolean;
  /**
   * RxN-only. Whether the viewer is on this player. Going inactive pauses playback
   */
  isActive?: boolean;
  onPlay?: () => void;
  onEnded?: () => void;
  onTimeUpdate?: (update: VideoTimeUpdate) => void;
  onSeek?: () => void;
  /**
   * Reports the clip's length once the browser has read its metadata. Web-only,
   * like `posterUrl`: the native player has no equivalent yet.
   */
  updateVideoDuration?: (durationSeconds: number) => void;
  /**
   * Any CSS length, capping how tall the player may grow
   */
  maxHeight?: string;
};
